var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolfClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.15 42.903L282.871 494.335C277.445 505.163 266.373 511.999 254.264 511.999H32C14.326 511.999 0 497.671 0 479.999V471.999H52C58.627 471.999 64 466.624 64 459.999S58.627 447.999 52 447.999H0V416H52C58.627 416 64 410.625 64 404S58.627 392 52 392H0V363.007C0 341.57 20.662 326.199 41.193 332.359L258.947 397.683L452.734 12.673C458.996 0.985 473.549 -3.413 485.232 2.852L499.338 10.419C511.016 16.68 515.408 31.223 509.15 42.903Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfClub);
export default __webpack_public_path__ + "static/media/golf-club.d9823edd7ea64c296d393f4ff626196f.svg";
export { ForwardRef as ReactComponent };